import { Box, Typography, useTheme } from "@mui/material";
import RoleBasedAccess from "../../services/RoleBasedAccess";

interface ProcessingErrorListProps {
  errors: any[];
}

const ProcessingErrorList: React.FC<ProcessingErrorListProps> = ({ errors }) => {
  const theme = useTheme();

  if (!errors?.length) return null;

  return (
    <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
      <Box
        sx={{
          mt: 2,
          backgroundColor: theme.palette.background.paper,
          p: 2,
          borderRadius: 3,
          maxHeight: "400px",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Processing Errors ({errors.length})
        </Typography>

        {errors.map((err, idx) => (
          <Box
            key={idx}
            sx={{
              backgroundColor: theme.palette.error.main,
              color: "white",
              borderRadius: 1,
              py: 1,
              px: 2,
              mb: 1,
            }}
          >
            <Typography variant="body2">
              <strong>{new Date(Number(err.timestamp)).toLocaleString()}:</strong> {err.message}
            </Typography>
            <Typography variant="body2">
              <strong>{err.service_name}</strong> — {err.exception_type} in{" "}
              <code>{err.function_name}</code> (line {err.line_number})
            </Typography>
            <Typography variant="body2">{err.exception_message}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              Correlation ID: {err.correlation_id}
            </Typography>
          </Box>
        ))}
      </Box>
    </RoleBasedAccess>
  );
};

export default ProcessingErrorList;
